export const PERMISSIONS = {
  RMS_VIEW: 'view:rms_page',
  RMS_RESTRICTED_ACTION: 'restricted_approve_reject:rms_page',
  UM_VIEW: 'view:um_page',
  REPORTS_VIEW: 'view:reports_page',
  AUDITS_VIEW: 'view:audit_page',
};


// Utility function to check if a user has a specific permission
export const hasPermission = (userPermissions, requiredPermission) => {
  return userPermissions.includes(requiredPermission);
};